module.exports = __webpack_public_path__ + "static/media/01-MGM_Casino_Fish_Restaurant.5502a068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mgm-casino/01-MGM_Casino_Fish_Restaurant.jpg
// module id = 338
// module chunks = 37